import { formatISO } from 'date-fns';
import { useCalendarDate } from './useCalendarDate';
import { useGetVehiclesQuery } from '../redux/transport';

export const useVehicleList = () => {
  const [date] = useCalendarDate(true);
  const data = useGetVehiclesQuery(formatISO(date, { representation: 'date' }));
  return data;
};
